module.exports = __webpack_public_path__ + "img/calendar.575d6eaa.svg";